<template>
  <div class="court-session">
    <Header></Header>
    <section>
      <div class="status">
        <div class="click" @click="_switchStatus(0)" :class="status_idx == 0 ? 'on': ''">待开庭({{ status_count.courtWait }})</div>
        <div class="click" @click="_switchStatus(1)" :class="status_idx == 1 ? 'on': ''">开庭中({{ status_count.courtOn }})</div>
        <div class="click" @click="_switchStatus(2)" :class="status_idx == 2 ? 'on': ''">已开庭({{ status_count.courtOver }})</div>
      </div>
      <div class="search">
        <a-input-search
          placeholder="输入案号"
          enter-button="搜索"
          size="large"
          @search="_search"
        />
      </div>
      <div class="list">
        <a-empty description="暂无数据" v-if="list.length === 0"/>
        <div v-for="(item, index) in list" :key="index" class="click" @click="_openDetail(item.id, item.state)">
          <div class="content">
            <div class="no ellipsis"><img src="../assets/icon_file.png" alt="">案号：{{ item.caseNo }}</div>
            <div class="info">
              <p class="ellipsis">申请人：{{ item.applicant }}</p>
              <p class="ellipsis">仲裁员：{{ item.arbitrator }}</p>
              <p class="ellipsis">秘书：{{ item.secretary }}</p>
              <p class="ellipsis">开庭时间：{{ item.arrangeTime }}</p>
              <p class="ellipsis">被申请人： {{ item.respondent }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="page"><a-pagination show-quick-jumper :current="param.page" :defaultPageSize="param.limit" :total="total" @change="_pageChange" /></div>
    </section>
    <CaseInfo :id="id" :status="caseInfoStatus" @handle="_popupHandle"/>
    <UploadFile :userType="memberType" :id="id" :status="uploadFileStatus" @handle="_popupHandle" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import CaseInfo from '@/components/CaseInfo'
import UploadFile from '@/components/UploadFile'
import { courtStatistics, courtList } from '@/service/getData'
export default {
  name: 'CourtSession',
  data () {
    return {
      status_idx: 0,
      status_count: {},
      list: [],
      id: 0,
      caseInfoStatus: false,
      uploadFileStatus: false,
      memberType: 0,
      param: {
        offset: 0,
        limit: 15,
        sort: 'ctime',
        order: 'desc',
        caseNo: '',
        page: 1
      },
      total: 0
    }
  },
  components: {
    Header,
    CaseInfo,
    UploadFile
  },
  created () {
    this.getStatusCount()
    this.getList()
  },
  methods: {

    /**
     * 搜索
     */
    _search (val) {
      this.param.caseNo = val
      if (!this.$verify.empty(this.param.caseNo)) {
        this.param.offset = 0
        this.param.page = 1
        this.getList()
      }
    },

    /**
     * 弹窗事件
     */
    _popupHandle (e) {
      switch (e.event) {
        case -1:
          this.caseInfoStatus = false
          this.uploadFileStatus = false
          break
        case 1:
          this.$router.push('/check')
          break
        case 2:
          this.memberType = e.data.memberType
          this.caseInfoStatus = false
          this.uploadFileStatus = true
          break
      }
    },

    /**
     * 打开详情
     */
    _openDetail (id, state) {
      if (state !== 2) {
        this.id = id
        this.caseInfoStatus = true
      }
    },

    /**
     * 页码切换
     */
    _pageChange (page) {
      this.param.page = page
      this.param.offset = this.param.limit * (page - 1)
      this.getList()
    },

    /**
     * 成员处理
     */
    member (arr) {
      for (var x = 0; x < arr.length; x++) {
        for (var y = 0; y < arr[x].meetingMemberDtoList.length; y++) {
          switch (arr[x].meetingMemberDtoList[y].memberType) {
            case 0:
              arr[x].applicant = arr[x].meetingMemberDtoList[y].name
              break
            case 1:
              arr[x].respondent = arr[x].meetingMemberDtoList[y].name
              break
            case 2:
              arr[x].arbitrator = arr[x].meetingMemberDtoList[y].name
              break
            case 3:
              arr[x].secretary = arr[x].meetingMemberDtoList[y].name
              break
          }
        }
      }
      return arr
    },

    /**
     * 选择状态
     */
    _switchStatus (idx) {
      if (idx !== this.status_idx) {
        this.list = []
        this.status_idx = idx
        this.param.offset = 0
        this.param.page = 1
        this.getList()
      }
    },

    /**
     * 获取列表数据
     */
    async getList () {
      var param = this.param
      param.state = this.status_idx
      var res = await courtList(this.param)
      this.list = []
      if (res.code === 1) {
        this.list = this.member(res.rows)
        this.total = res.total
      }
    },

    /**
     * 获取状态数量
     */
    async getStatusCount () {
      var res = await courtStatistics()
      this.status_count = res.data
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.court-session {
  background-color: #F7F8FA;
  width: 100%;
  height: 100%;
  .page {
    text-align: right;
    margin-right: 0.833rem;
  }
  .search {
    height: 0.5rem;
    width: 6.95rem;
    margin: 0 auto;
    margin-top: 0.333rem;
    &>span {
      height: 100%;
      &>span {
        height: 100%;
      }
      input {
        height: 100%;
        border: 1px solid #3D97E6;
        border-radius: 0.042rem  0rem   0rem  0.042rem;
      }
      button {
        height: 100%;
        padding: 0 0.45rem;
        border-radius: 0rem  0.042rem   0.042rem  0rem;
        span {
          color: #fff;
        }
      }
    }
  }
  .list {
    height: 6.125rem;
    display: flex;
    padding-left: 0.458rem;
    padding-right: 0.291rem;
    padding-top: 0.125rem;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    position: relative;
    .ant-empty {
      @include center;
    }
    &>div {
      width: 20%;
      height: 1.917rem;
      padding-top: 0.167rem;
      .content {
        overflow: hidden;
        margin-right: 0.167rem;
        height: 1.75rem;
        background-color: #fff;
        border-radius: 0.083rem;
        box-shadow:0rem 0rem 0.1rem 0rem rgba(151,151,151,0.2);
        .info {
          font-size: 0.117rem;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(102,102,102,1);
          margin: 0 0.358rem;
          line-height: 0.26rem;
          position: relative;
          a {
            position: absolute;
            right: 0;
            color: #267CD0
          }
        }
        .no {
          background-color: #D5EAFF;
          font-size: 0.133rem;
          font-family: PingFang SC;
          font-weight: bold;
          text-align: center;
          line-height: 0.367rem;
          color: #333333;
          img {
            vertical-align: middle;
            margin-right: 0.058rem;
            width: 0.15rem;
            height: 0.133rem;
          }
        }
      }
    }
  }
  .status {
    width: 12.067rem;
    height: 0.417rem;
    line-height: 0.417rem;
    background-color: #E7E7E7;
    display: flex;
    border-radius: 0.167rem;
    margin: 0 auto;
    text-align: center;
    margin-top: 0.292rem;
    position: relative;
    div {
      flex: 1;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      &.on {
        background-color: #3D97E6;
        color: #fff;
        border-radius: 0.167rem;
      }
    }
  }
}
</style>
